<template>
  <v-container
    id="search-listings"
    fluid
    class="mt-3"
  >
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <beds-filter
      :show-beds-filter="showBedsFilter"
      :min-beds="numBedroomsMin"
      :max-beds="numBedroomsMax"
      :min-baths="numBathroomsMin"
      :max-baths="numBathroomsMax"
      @hideBedsFilterOverlay="hideBedsFilterOverlay"
      @setMinBeds="setMinBeds"
      @setMaxBeds="setMaxBeds"
      @setMinBaths="setMinBaths"
      @setMaxBaths="setMaxBaths"
      @load="load"
    />
    <hometype-filter
      :show-hometype-filter="showHometypeFilter"
      :land="homeTypeLand"
      :apartment="homeTypeApartment"
      :multi-family="homeTypeMultiFamily"
      :single-family="homeTypeSingleFamily"
      :others="homeTypeOthers"
      @hideHometypeFilterOverlay="hideHometypeFilterOverlay"
      @setHomeTypeSingleFamily="setHomeTypeSingleFamily"
      @setHomeTypeMultiFamily="setHomeTypeMultiFamily"
      @setHomeTypeApartment="setHomeTypeApartment"
      @setHomeTypeLand="setHomeTypeLand"
      @setHomeTypeOthers="setHomeTypeOthers"
      @setHomeTypes="setHomeTypes"
      @load="load"
    />
    <forecasting-filter
      :show-forecasting-filter="showForecastingFilter"
      @hideForecastingFilterOverlay="hideForecastingFilterOverlay"
      @setForecastedGrowthPercent="setForecastedGrowthPercent"
      @setForecastedGrowthDollar="setForecastedGrowthDollar"
      @setForecastedYear="setForecastedYear"
      @load="load"
    />
    <pricing-filter
      :show-pricing-filter="showPricingFilter"
      @hidePricingFilterOverlay="hidePricingFilterOverlay"
      @setPriceRange="setPriceRange"
      @load="load"
    />
    <market-filter
      :show-market-filter="showMarketFilter"
      @hideMarketFilterOverlay="hideMarketFilterOverlay"
    />
    <details-filter
      :show-details-filter="showDetailsFilter"
      :parking-spot="propertyDetailsParkingSpot"
      :garage="propertyDetailsGarage"
      :foreclosed="propertyDetailsForeclosed"
      :pool="propertyDetailsPool"
      :basement="propertyDetailsBasement"
      @hideDetailsFilterOverlay="hideDetailsFilterOverlay"
      @setPropertyDetailsParkingSpot="setPropertyDetailsParkingSpot"
      @setPropertyDetailsGarage="setPropertyDetailsGarage"
      @setPropertyDetailsForeclosed="setPropertyDetailsForeclosed"
      @setPropertyDetailsPool="setPropertyDetailsPool"
      @setPropertyDetailsBasement="setPropertyDetailsBasement"
      @setPropertyDetails="setPropertyDetails"
      @load="load"
    />
    <v-row
      v-if="showListings && !noAddressEntries && query"
    >
      <v-col
        cols="12"
        md="10"
        class="green-buttons"
      >
      <v-row
        v-bind:class="{ singleListingMobile: isSingleListing }"
      >
        <h3
        class="filters-heading"
        >
          Customize your property search:
        </h3>
      </v-row>
      <v-row
        v-bind:class="{ singleListingMobile: isSingleListing }"
      >
        <v-btn
          text
          @click="displayPricingFilter()"
          class="first-filter-button"
        >
          Price Range
        </v-btn>
        <!-- <v-btn
          text
          @click="displayMarketFilter()"
        >
          Market Info
        </v-btn> -->
        <v-btn
          text
          @click="displayBedsFilter()"
        >
          Bed &amp; Bath
        </v-btn>
        <v-btn
          text
          @click="displayHometypeFilter()"
        >
          Home Type
        </v-btn>
        <v-btn
          text
          @click="displayDetailsFilter()"
        >
          Property Details
        </v-btn>
        <v-btn
          text
          @click="displayForecastingFilter()"
        >
          Forecasting
        </v-btn>
      </v-row>
      </v-col>
      <v-spacer />
      <v-col
        v-if="query"
        cols="12"
        md="2"
        class="squash-buttons text-center"
      >
        <v-btn
          text
          elevation="3"
          @click="onToggleSearch"
          v-if="!isSavedSearch"
        >
          Save This Search
          <v-icon>
            {{ 'mdi-heart-outline' }}
          </v-icon>
        </v-btn>
        <v-btn
          text
          elevation="3"
          @click="onToggleSearch"
          v-if="isSavedSearch"
        >
          Unsave This Search
          <v-icon>
            {{ 'mdi-heart' }}
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      id="search-listings-content"
    >
      <v-col
        id="map-col"
        :cols="noAddressEntries ? '0' : '12'"
        :md="noAddressEntries ? '0' : '8'"
        class="d-flex"
      >
        <div id="map" />
      </v-col>
      <v-col
        cols="12"
        :md="noAddressEntries ? '12' : '4'"
        class="found-properties-column d-flex flex-column"
      >
        <v-row
        v-if="query"
        >
          <v-col
            cols="12"
            class="pb-0"
          >
            <div
              class="found-properties-header"
            >
              <h2>
                <template v-if="query && (query !== 'undefined') && !noAddressEntries">
                  <!-- &ldquo;{{ query }}&rdquo; -->
                  {{ query }}
                </template>
                <br v-if="filterChips.length">
                <v-chip
                  v-for="(item, i) in filterChips"
                  :key="i"
                  class="ma-2"
                  close
                  @click:close="removeFilter(item)"
                >
                  {{ item }}
                </v-chip>
                <!-- <br><span v-if="!noAddressEntries && query">{{ totalResults }} results</span> -->
              </h2>
              <p
                v-if="noAddressEntries"
                class="listings-error"
              >
                <template v-if="filterChips.length">
                  We could not find listings for this area and filters. Please check your spelling, enter a valid ZIP code, or remove some filters.
                </template>
                <template v-else>
                  We could not find listings for this area. Please check your spelling or enter a valid ZIP code.
                </template>
              </p>
              <p
                v-if="listingsError && !noAddressEntries"
                class="listings-error"
              >
                {{ listingsError }}
              </p>
              <v-select
                v-if="!noAddressEntries"
                v-model="order"
                :items="sortOptions"
                item-text="name"
                item-value="order"
                label="Sort by"
                @change="load"
              />
            </div>
          </v-col>
        </v-row>
        <v-row
          v-for="item in listings"
          :key="item.id"
          class="listings-item-row"
        >
          <v-col
            cols="12"
          >
          <!-- <router-link
          style="text-decoration: none; color: inherit;"
          :to="{ name: 'Listing', params: { fips: item.fips, apn: item.apn }, query: { address: query }}"
          > -->
            <property-listings-card
              :item="item"
              :query="query"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-pagination
                v-if="!noAddressEntries"
                style="width: 100%"
                v-model="page"
                :length="totalPages"
                @input="onPageChange"
                circle
              />
              <base-img
              v-if="noAddressEntries"
      :src="'https://www.honely.com/img/logo.4bb82f35.svg'"
      class="mx-auto mb-12"
      contain
      height="150"
      width="150"
    />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios'
  // import SearchSuggestions from '@/components/SearchSuggestions'
  import Scriptjs from 'scriptjs'
  import { mapGetters } from 'vuex'
  import { bus } from '../../main'

  /* global google */

  export default {
    components: {
      // SearchSuggestions,
      PropertyListingsCard: () => import('@/components/PropertyListingsCard'),
      BedsFilter: () => import('@/components/listing_filters/BedsFilter'),
      HometypeFilter: () => import('@/components/listing_filters/HometypeFilter'),
      ForecastingFilter: () => import('@/components/listing_filters/ForecastingFilter'),
      PricingFilter: () => import('@/components/listing_filters/PricingFilter'),
      MarketFilter: () => import('@/components/listing_filters/MarketFilter'),
      DetailsFilter: () => import('@/components/listing_filters/DetailsFilter'),
    },

    data: () => ({
      user: null,
      isSavedSearch: false,
      savedSearchCount: null,
      page: 1,
      loading: false,
      ready: false,
      showListings: true,
      // noAddressEntries: false,
      // listings: [],
      // totalResults: '',
      query: '',
      center: { lat: 51.093048, lng: 6.842120 },
      markers: [
      ],
      order: '',
      sortOptions: [
        { order: 'newest.desc', name: 'Newest' },
        { order: 'price.desc', name: 'Price (high to low)' },
        { order: 'price.asc', name: 'Price (low to high)' },
        { order: 'bedrooms.desc', name: 'Bedrooms' },
        { order: 'bathrooms.desc', name: 'Bathrooms' },
        { order: 'square_feet.desc', name: 'Square Feet' },
        // { order: 'lot_size.desc', name: 'Lot Size' },
      ],

      squareFeetMin: null,
      squareFeetMax: null,
      lotSizeMin: null,
      lotSizeMax: null,
      numBedroomsMin: 'No Minimum',
      numBedroomsMax: 'No Maximum',
      numBathroomsMin: 'No Minimum',
      numBathroomsMax: 'No Maximum',
      priceMin: null,
      priceMax: null,
      homeTypeLand: null,
      homeTypeApartment: null,
      homeTypeMultiFamily: null,
      homeTypeSingleFamily: null,
      homeTypeOthers: null,
      propertyDetailsParkingSpot: null,
      propertyDetailsGarage: null,
      propertyDetailsForeclosed: null,
      propertyDetailsPool: null,
      propertyDetailsBasement: null,

      forecastedGrowthPercent: 0,
      forecastedGrowthDollar: 0,
      forecastedYear: 0,
      priceRange: 0,

      // forecastPercentItems: [
      //   // { name: 'Any', value: 'Any' },
      //   // { name: '0-5%', value: '0-5%' },
      //   // { name: '5%-10%', value: '5%-10%' },
      //   // { name: '10%-15%', value: '10%-15%' },
      //   // { name: '15%+', value: '15%' },
      //   'Any', '0-5%', '5%-10%', '10%-15%', '15%',
      // ],
      // forecastDollarItems: ['Any', '100k-500k', '500k-1m', '1m-1.5m', '1.5m-2m', '2m+'],

      homeTypes: [],
      propertyDetails: [],

      map: null,
      marker: null,
      infoWindow: null,

      // center around the Upper West Side, NYC
      DEFAULT_LAT: 40.780,
      DEFAULT_LNG: -73.974,

      geocoder: null,

      savedSearchId: null,

      showBedsFilter: false,
      showHometypeFilter: false,
      showForecastingFilter: false,
      showPricingFilter: false,
      showMarketFilter: false,
      showDetailsFilter: false,
      lat: null,
      long: null,
    }),

    computed: {
      ...mapGetters('listings', ['allListings', 'totalResults', 'noAddressEntries', 'listingsError']),
      ...mapGetters('auth', ['loggedIn', 'username', 'vxAuth', 'vxAuthDependent', 'isCognitoUserLoggedIn', 'cognitoUser']),
      sortBy: function () {
        return this.order.split('.')[0]
      },
      sortOrder: function () {
        return this.order.split('.')[1]
      },
      listings: function () {
        return this.$store.getters['listings/allListings']
      },
      totalPages: function () {
        var totalListings = this.$store.getters['listings/totalResults']
        // console.log('total listing: ' + totalListings)

        if (totalListings <= 0 || totalListings === 1 || totalListings === 20) {
          return 1
        } else if (totalListings > 600) {
          return 30
        } else {
          // console.log(Number(parseInt(totalListings / 20) + 1))
          return Number(parseInt(totalListings / 20) + 1)
        }
      },
      forecastedGrowthPercentValue: function () {
        // return this.forecastPercentItems[this.forecastedGrowthPercent].value
        return 0
      },
      forecastedGrowthDollarValue: function () {
        // return this.forecastDollarItems[this.forecastedGrowthDollar]
        return 0
      },
      forecastedYearValue: function () {
        return this.forecastedYear
      },
      priceRangeValue: function () {
        return this.priceRange
      },
      filterChips: function () {
        const chipsArray = []

        if (this.numBedroomsMin && this.numBedroomsMin !== 'No Minimum') {
          chipsArray.push('Min Beds ' + this.numBedroomsMin)
        }
        if (this.numBedroomsMax && this.numBedroomsMax !== 'No Maximum') {
          chipsArray.push('Max Beds ' + this.numBedroomsMax)
        }
        if (this.numBathroomsMin && this.numBathroomsMin !== 'No Minimum') {
          chipsArray.push('Min Baths ' + this.numBathroomsMin)
        }
        if (this.numBathroomsMax && this.numBathroomsMax !== 'No Maximum') {
          chipsArray.push('Max Baths ' + this.numBathroomsMax)
        }

        if (this.homeTypeSingleFamily) {
          chipsArray.push('Single Family')
        }
        if (this.homeTypeMultiFamily) {
          chipsArray.push('Multi Family')
        }
        if (this.homeTypeLand) {
          chipsArray.push('Land')
        }
        if (this.homeTypeApartment) {
          chipsArray.push('Apartment')
        }
        if (this.homeTypeOthers) {
          chipsArray.push('Others')
        }

        if (this.propertyDetailsParkingSpot) {
          chipsArray.push('Parking Spot')
        }
        if (this.propertyDetailsGarage) {
          chipsArray.push('Garage')
        }
        if (this.propertyDetailsForeclosed) {
          chipsArray.push('Foreclosed')
        }
        if (this.propertyDetailsPool) {
          chipsArray.push('Pool')
        }
        if (this.propertyDetailsBasement) {
          chipsArray.push('Basement')
        }

        if (this.forecastedGrowthPercent) {
          // chipsArray.push(this.forecastedYearValue + ' yr % growth ' + this.forecastedGrowthPercentValue)
          chipsArray.push(this.forecastedYearValue + ' yr % growth ' + this.forecastedGrowthPercent)
        }
        if (this.forecastedGrowthDollar) {
          chipsArray.push(this.forecastedYearValue + ' yr $ growth ' + this.forecastedGrowthDollar)
        }
        if (this.priceRange) {
          if (!String(this.priceRange).includes('-')) {
            chipsArray.push('Valuation' + this.priceRange + '+')
          } else {
            chipsArray.push('Valuation' + this.priceRange)
          }
        }

        // console.log(this.homeType yr % growths)
        // if (this.homeTypes) {
        //   this.homeTypes.forEach(function (x) {
        //     chipsArray.push(x)
        //   })
        // }
        // if (this.propertyDetails) {
        //   this.propertyDetails.forEach(function (x) {
        //     chipsArray.push(x)
        //   })
        // }

        return chipsArray
      },
      isSingleListing () {
        const total = this.$store.getters['listings/totalResults']
        const filterCounts = document.getElementsByClassName('ma-2').length
        // console.log('total listing: ' + Number(total))
        // console.log('total filters applied: ' + Number(filterCounts))
        if (total) {
          if (total === 1 && filterCounts === 0) {
            // console.log('single listing found')
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
    },

    watch: {
      $route (to, from) {
        this.lat = this.$route.query.lat
        this.long = this.$route.query.long
        this.query = this.$route.query.address
        this.page = this.$route.query.offset + 1
        this.squareFeetMin = null
        this.squareFeetMax = null
        this.lotSizeMin = null
        this.lotSizeMax = null
        this.numBedroomsMin = 'No Minimum'
        this.numBedroomsMax = 'No Maximum'
        this.numBathroomsMin = 'No Minimum'
        this.numBathroomsMax = 'No Maximum'
        this.priceMin = null
        this.priceMax = null

        this.homeTypeLand = null
        this.homeTypeApartment = null
        this.homeTypeMultiFamily = null
        this.homeTypeSingleFamily = null
        this.homeTypeOthers = null
        this.propertyDetailsParkingSpot = null
        this.propertyDetailsGarage = null
        this.propertyDetailsForeclosed = null
        this.propertyDetailsPool = null
        this.propertyDetailsBasement = null

        this.forecastedGrowthPercent = 0
        this.forecastedGrowthDollar = 0
        this.forecastedYear = 0
        this.priceRange = 0

        this.homeTypes = []
        this.propertyDetails = []

        this.load()
      },
    },

    mounted () {
      Scriptjs('https://maps.googleapis.com/maps/api/js?key=' + this.$mapsKey, () => {
        this.initMap()
      })

      if (this.$store.getters['auth/loggedIn']) {
        this.$store.dispatch('listings/getFavorites')
      }
    },

    created () {
      this.lat = this.$route.query.lat
      this.long = this.$route.query.long
      this.query = this.$route.query.address
    },

    methods: {
      onPageChange (value) {
        console.log('vx: onPageChange and therefore load being called. this.page being set to ', value)
        this.page = value
        console.log('vx: this.query from onpagechange', this.query)
        this.load()
      },
      initMap () {
        // const me = this

        this.map = new google.maps.Map(document.getElementById('map'), {
          center: {
            lat: this.DEFAULT_LAT,
            lng: this.DEFAULT_LNG,
          },
        })

        this.infoWindow = new google.maps.InfoWindow({
          content: '',
        })

        const me = this

        google.maps.event.addListener(me.map, 'zoom_changed', function () {
          google.maps.event.addListener(me.map, 'bounds_changed', function (event) {
            if (this.getZoom() > 15) {
              // Change max/min zoom here
              this.setZoom(15)
              this.initialZoom = false
            }
          })
        })

        this.ready = true
        if (this.query) {
          this.geoCodeAddress(this.query)
        }
        this.load()
      },
      load () {
        if (this.$useDevVariables) {
          // eslint-disable-next-line
          this.listings = [{"fips":"36061","apn":"00396-002017 05","unit_type":"APT","full_address":"626 E 14 ST APT 17 NEW YORK NY 10009 3334","longitude":-73.976781,"latitude":40.728591,"property_value":420000,"year_built":"1920.0","beds_count":null,"baths":null,"total_area_sq_ft":"65585.0","parking_spaces_count":null},{"fips":"36061","apn":"00558-1131","unit_type":"APT","full_address":"115 4 AVE APT 4J NEW YORK NY 10003 4908","longitude":-73.989573,"latitude":40.732812,"property_value":1856000,"year_built":null,"beds_count":null,"baths":null,"total_area_sq_ft":"1132.0","parking_spaces_count":null},{"fips":"36061","apn":"00576-00162G","unit_type":"APT","full_address":"42 W 13 ST APT 2G NEW YORK NY 10011 7921","longitude":-73.9964,"latitude":40.736027,"property_value":1764000,"year_built":"1960.0","beds_count":null,"baths":null,"total_area_sq_ft":"31540.0","parking_spaces_count":null},{"fips":"36061","apn":"00693-1115","unit_type":"APT","full_address":"551 W 21 ST APT 5B NEW YORK NY 10011 2895","longitude":-74.007302,"latitude":40.747579,"property_value":2509000,"year_built":null,"beds_count":null,"baths":null,"total_area_sq_ft":null,"parking_spaces_count":null},{"fips":"36061","apn":"00826-1063","unit_type":"APT","full_address":"1107 BROADWAY APT 10A NEW YORK NY 10010 0012","longitude":-73.989581,"latitude":40.742717,"property_value":3410000,"year_built":"1915.0","beds_count":null,"baths":null,"total_area_sq_ft":"2205.0","parking_spaces_count":null},{"fips":"36061","apn":"00846-00642E","unit_type":"#","full_address":"18 E 18 ST # 2E NEW YORK NY 10003 1910","longitude":-73.99078100000001,"latitude":40.737858,"property_value":2716000,"year_built":"1900.0","beds_count":null,"baths":null,"total_area_sq_ft":"36400.0","parking_spaces_count":null},{"fips":"36061","apn":"00892-002510A","unit_type":"#","full_address":"273 LEXINGTON AVE # 10A NEW YORK NY 10016 3540","longitude":-73.978376,"latitude":40.74775800000001,"property_value":626000,"year_built":"1966.0","beds_count":null,"baths":null,"total_area_sq_ft":"129964.0","parking_spaces_count":null},{"fips":"36061","apn":"00893-004121H","unit_type":"#","full_address":"560 3 AVE # 21H NEW YORK NY 10016 3117","longitude":-73.976864,"latitude":40.748094,"property_value":699000,"year_built":"1975.0","beds_count":null,"baths":null,"total_area_sq_ft":"329706.0","parking_spaces_count":null},{"fips":"36061","apn":"01047-1468","unit_type":"APT","full_address":"353 W 56 ST APT 2C NEW YORK NY 10019 3773","longitude":-73.985076,"latitude":40.767173,"property_value":603000,"year_built":"1931.0","beds_count":null,"baths":null,"total_area_sq_ft":"534.0","parking_spaces_count":null},{"fips":"36061","apn":"01066-00372O","unit_type":"APT","full_address":"408 W 57 ST APT 2O NEW YORK NY 10019 3018","longitude":-73.986621,"latitude":40.767949,"property_value":457000,"year_built":"1957.0","beds_count":null,"baths":null,"total_area_sq_ft":"104966.0","parking_spaces_count":null},{"fips":"36061","apn":"01124-00058D","unit_type":"APT","full_address":"59 W 71 ST APT 8D NEW YORK NY 10023 4115","longitude":-73.978514,"latitude":40.776651,"property_value":998000,"year_built":"1924.0","beds_count":null,"baths":null,"total_area_sq_ft":"54976.0","parking_spaces_count":null},{"fips":"36061","apn":"01147-10036G","unit_type":"#","full_address":"161 W 75 ST # 6G NEW YORK NY 10023 1801","longitude":-73.979637,"latitude":40.780676,"property_value":1381000,"year_built":"1925.0","beds_count":null,"baths":null,"total_area_sq_ft":"181976.0","parking_spaces_count":null},{"fips":"36061","apn":"01242-0062 02","unit_type":"#","full_address":"706 W END AVE # SUPER1A NEW YORK NY 10025 6496","longitude":-73.973569,"latitude":40.794203,"property_value":574000,"year_built":"1928.0","beds_count":null,"baths":null,"total_area_sq_ft":"99494.0","parking_spaces_count":null},{"fips":"36061","apn":"01343-100211A","unit_type":"APT","full_address":"319 E 50 ST APT 11A NEW YORK NY 10022 7948","longitude":-73.967511,"latitude":40.754762,"property_value":524000,"year_built":"1931.0","beds_count":null,"baths":null,"total_area_sq_ft":"79062.0","parking_spaces_count":null},{"fips":"36061","apn":"01407-003314E","unit_type":"#","full_address":"1250 3 AVE # 14E NEW YORK NY 10021 ","longitude":-73.960649,"latitude":40.770244,"property_value":831000,"year_built":"1960.0","beds_count":null,"baths":null,"total_area_sq_ft":"326054.0","parking_spaces_count":null},{"fips":"36061","apn":"01487-1303","unit_type":"APT","full_address":"530 E 76 ST APT 18H NEW YORK NY 10021 3159","longitude":-73.950085,"latitude":40.768188,"property_value":1511000,"year_built":"1986.0","beds_count":null,"baths":null,"total_area_sq_ft":"1007.0","parking_spaces_count":null},{"fips":"36061","apn":"01492-00612B","unit_type":"APT","full_address":"18 E 81 ST APT 2B NEW YORK NY 10028 0232","longitude":-73.96185799999998,"latitude":40.777682,"property_value":928000,"year_built":"1930.0","beds_count":null,"baths":null,"total_area_sq_ft":"13050.0","parking_spaces_count":null},{"fips":"36061","apn":"01527-1023","unit_type":"APT","full_address":"1441 3 AVE APT 9C NEW YORK NY 10028 1976","longitude":-73.955859,"latitude":40.775694,"property_value":1481000,"year_built":"1984.0","beds_count":null,"baths":null,"total_area_sq_ft":"1220.0","parking_spaces_count":null},{"fips":"36061","apn":"01551-00443B","unit_type":"APT","full_address":"312 E 89 ST APT 3B NEW YORK NY 10128 5095","longitude":-73.949572,"latitude":40.779235,"property_value":337000,"year_built":"1960.0","beds_count":null,"baths":null,"total_area_sq_ft":"9165.0","parking_spaces_count":null},{"fips":"36061","apn":"01566-00142C","unit_type":"#","full_address":"431 E 86 ST # 2C NEW YORK NY 10028 ","longitude":-73.94789200000002,"latitude":40.776591,"property_value":1173000,"year_built":"1910.0","beds_count":null,"baths":null,"total_area_sq_ft":"33500.0","parking_spaces_count":null}]
          this.totalResults = this.listings.length
          this.setMarkers()
        } else {
          this.loading = true
          // this.hideBedsFilterOverlay()

          this.$store.dispatch('listings/getListings', {
            query: this.query,
            offset: this.page - 1,
            sortBy: this.sortBy,
            sortOrder: this.sortOrder,
            squareFeetMin: this.squareFeetMin,
            squareFeetMax: this.squareFeetMax,
            lotSizeMin: this.lotSizeMin,
            lotSizeMax: this.lotSizeMax,
            numBedroomsMin: this.numBedroomsMin,
            numBedroomsMax: this.numBedroomsMax,
            numBathroomsMin: this.numBathroomsMin,
            numBathroomsMax: this.numBathroomsMax,
            priceMin: this.priceMin,
            priceMax: this.priceMax,
            forecastedGrowthPercent: this.forecastedGrowthPercent,
            forecastedGrowthDollar: this.forecastedGrowthDollar,
            forecastedYear: this.forecastedYearValue,
            priceRange: this.priceRange,
            homeTypes: this.homeTypes,
            propertyDetails: this.propertyDetails,
            lat: this.lat,
            long: this.long,
          })
            .then(() => {
              this.loading = false

              /* if (this.listings.length === 1) {
                this.showListings = false
                // this.$router.push({ name: 'Listing', params: { fips: this.listings[0].fips, apn: this.listings[0].apn } })
                this.$router.push({ name: 'ListingId', params: { property_id: this.listings[0].property_id } })
              } else */ if (this.listings.length > 0) {
                this.setMarkers()
              } else {
                this.geoCodeAddress(this.query)
              }
            })
          if (this.$useDevVariables) {
            this.user = {
              user_id: null,
              first_name: 'Sample',
              last_name: 'Sample',
              email: null,
              phone_number: null,
              lookup_count: null,
              membership_type: null,
            }
          } else {
            if (this.$store.getters['auth/isCognitoUserLoggedIn']) {
              axios.get('https://api.honely.com/lookup/user_profile', {
                params: {
                  email: this.$store.getters['auth/cognitoUser'].attributes.email,
                },
              }).then((response) => {
                this.user = response.data
                this.getSavedSearches()
              }).catch((error) => {
                console.log('[ERROR] Failed to fetch user data', error)
                console.log(error.response.data.errorMessage)
              })
            }
          }
        }
      },

      setMarkers () {
        this.markers.forEach(function (marker) {
          marker.setMap(null)
        })
        this.markers = []

        this.listings.forEach(function (listing) {
          listing.additional_images = null

          this.addMarker(parseFloat(listing.latitude), parseFloat(listing.longitude), listing)
        }, this)

        const me = this

        setTimeout(function () {
          var bounds = new google.maps.LatLngBounds()
          me.markers.forEach(function (marker) {
            bounds.extend(marker.getPosition())
          })
          me.map.fitBounds(bounds)
        }, 500)
      },

      onAddressChange (value) {
        this.query = value
        this.geoCodeAddress(value)
        this.load()
      },

      geoCodeAddress (address, price = null, addMarker = false) {
        var me = this

        if (!this.geocoder) {
          this.geocoder = new google.maps.Geocoder()
        }

        this.geocoder.geocode({ address: address }, function (results, status) {
          if (status === 'OK') {
            me.map.setCenter(results[0].geometry.location)
          } else {
            console.log(address + 'Geocode was not successful for the following reason: ' + status)
          }
        })
      },

      addMarker (latitude, longitude, listing) {
        if (this.ready) {
          if (latitude && longitude) {
            const map = this.map

            const marker = new google.maps.Marker({
              position: { lat: latitude, lng: longitude },
              label: '',
              map: map,
            })

            let contentString = '<a style="text-decoration: none" href= "/listing/' + listing.property_id + '"><div class="card-pricing">'
            // let contentString = '<a class="card-pricing" style="text-decoration: none" href= "/listing/' + listing.property_id + '"><div class="card-pricing">'
            // let contentString = '<div class="card-pricing">'
            // let contentString = '<div onclick="window.location.href=\'/listing/' + listing.property_id + '\'" class="card-pricing">'

            if (listing.full_address) {
              contentString += '<div  class="addressinfo">' + listing.full_address + '</div>'
              // contentString += '<a style="text-decoration: none" href= "/listing/' + listing.property_id + '"><div  class="addressinfo">' + listing.full_address + '</div></a>'
            }

            // if (listing.list_price) {
            //   contentString += '<span class="priceline pl-list">$' + this.formatPrice(listing.list_price) + ' <span class="pricecat">list</span></span>'
            // } else if (listing.appraisal) {
            //   contentString += '<span class="priceline pl-appraisal">$' + this.formatPrice(listing.appraisal) + ' <span class="pricecat">appraisal</span></span>'
            // }
            // if (listing.assessed_value) {
            //   contentString += '<span class="priceline pl-valuation">$' + this.formatPrice(listing.assessed_value) + ' <span class="pricecat">valuation</span></span>'
            // }

            // if (listing.list_price && ((listing.for_sale === 'Active') || (listing.for_sale === 'For Sale') || (listing.for_sale === 'PENDING') || (listing.for_sale === 'Contingent'))) {
            //   contentString += '<span class="priceline pl-list">$' + this.formatPrice(listing.list_price) + ' <span class="pricecat">list</span></span>'
            // }
            if (listing.appraisal) {
              contentString += '<span class="priceline pl-valuation">$' + this.formatPrice(listing.appraisal) + ' <span class="pricecat">Honely Value Estimate</span></span>'
            }

            contentString += '</div></a>'
            // contentString += '</div>'

            var me = this

            if (this.$vuetify.breakpoint.xs) {
              marker.addListener('click', () => {
                me.infoWindow.setContent(contentString)

                me.infoWindow.open({
                  anchor: marker,
                  map,
                  shouldFocus: false,
                })
              })
            } else {
              marker.addListener('mouseover', () => {
                me.infoWindow.setContent(contentString)

                me.infoWindow.open({
                  anchor: marker,
                  map,
                  shouldFocus: false,
                })
              })
            }

            this.markers.push(marker)
          }
        } else {
          const me = this
          setTimeout(function () {
            me.addMarker(latitude, longitude, listing)
          }, 500)
        }
      },

      getSavedSearches () {
        if (this.$store.getters['auth/isCognitoUserLoggedIn']) {
          // axios.get('/api/v1/saved-searches',
          //           {
          //             headers: {
          //               Authorization: 'Bearer ' + this.currentUser,
          //             },
          //           })
          //   .then((response) => {
          //     const row = response.data.rows.find(item => item.search === this.query)
          //     if (row) {
          //       this.savedSearchId = row.id
          //     }
          //   })
          //   .catch(err => {
          //     console.log(err)
          //     this.regError = err.response.data
          //   })
          axios.get('https://api.honely.com/lookup/saved_searches?user_id=' + this.user.user_id)
            .then((response) => {
              const row = response.data.find(item => item.search === this.query)
              if (row) {
                this.isSavedSearch = true
              } else {
                this.isSavedSearch = false
              }
              this.savedSearchCount = response.data.length
            })
            .catch((error) => {
              console.log('Error fetching saved searches: ', error)
            })
        }
      },
      onToggleSearch () {
        if (this.$store.getters['auth/isCognitoUserLoggedIn']) {
          if (this.isSavedSearch) {
            this.removeSaveSearch()
          } else {
            if (this.savedSearchCount < 20) {
              this.saveSearch()
            } else {
              bus.$emit('showError', { message: 'You have reached the maximum limit of saved searches (20).' })
            }
          }
        } else {
          bus.$emit('showError', { message: 'Please log in or create an account to save this search' })
        }
        // if (this.$store.getters['auth/loggedIn']) {
        //   if (this.savedSearchId) {
        //     this.removeSaveSearch()
        //   } else {
        //     this.saveSearch()
        //   }
        // } else {
        //   bus.$emit('showError', { message: 'Please log in or create an account to save this search' })
        // }
      },
      saveSearch () {
        const params = {
          user_id: this.user.user_id,
          search: this.query,
        }
        // axios.post('/api/v1/saved-searches', params,
        //            {
        //              headers: {
        //                Authorization: 'Bearer ' + this.currentUser,
        //              },
        //            })
        //   .then((response) => {
        //     this.savedSearchId = response.data.id
        //   })
        //   .catch(err => {
        //     console.log(err)
        //     this.regError = err.response.data
        //   })
        axios.post('https://api.honely.com/lookup/insert_searches', params)
          .then(() => {
            this.isSavedSearch = true
            this.savedSearchCount = this.savedSearchCount + 1
          })
          .catch(err => {
            console.log('Error inserting saved search', err)
            // this.regError = err.response.data
          })
      },
      removeSaveSearch () {
        const params = {
          user_id: this.user.user_id,
          search: this.query,
        }
        // axios.delete('/api/v1/saved-searches/' + this.savedSearchId,
        //              {
        //                headers: {
        //                  Authorization: 'Bearer ' + this.currentUser,
        //                },
        //              })
        //   .then((response) => {
        //     this.savedSearchId = null
        //   })
        //   .catch(err => {
        //     console.log(err)
        //     this.regError = err.response.data
        //   })
        axios.delete('https://api.honely.com/lookup/delete_searches', { data: params })
          .then(() => {
            this.isSavedSearch = false
            this.savedSearchCount = this.savedSearchCount - 1
          })
          .catch((err) => {
            console.log('Error deleting saved search', err)
          })
      },

      formatPrice (value) {
        // let val = (value/1).toFixed(2).replace('.', ',')
        if (value) {
          value = value.toString().split('.')[0]
          value = parseInt(value)
          value = (value % 100 >= 50) ? Math.ceil(value / 100) * 100 : Math.floor(value / 100) * 100
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return '--'
        }
      },

      displayBedsFilter () {
        this.showBedsFilter = true
      },
      hideBedsFilterOverlay () {
        this.showBedsFilter = false
      },
      displayHometypeFilter () {
        this.showHometypeFilter = true
      },
      hideHometypeFilterOverlay () {
        this.showHometypeFilter = false
      },
      displayForecastingFilter () {
        this.showForecastingFilter = true
      },
      hideForecastingFilterOverlay () {
        this.showForecastingFilter = false
      },
      displayPricingFilter () {
        this.showPricingFilter = true
      },
      hidePricingFilterOverlay () {
        this.showPricingFilter = false
      },
      displayMarketFilter () {
        this.showMarketFilter = true
      },
      hideMarketFilterOverlay () {
        this.showMarketFilter = false
      },
      displayDetailsFilter () {
        this.showDetailsFilter = true
      },
      hideDetailsFilterOverlay () {
        this.showDetailsFilter = false
      },
      setMinBeds (value) {
        this.numBedroomsMin = value
      },
      setMaxBeds (value) {
        this.numBedroomsMax = value
      },
      setMinBaths (value) {
        this.numBathroomsMin = value
      },
      setMaxBaths (value) {
        this.numBathroomsMax = value
      },
      setForecastedGrowthPercent (value) {
        console.log('forecast growth precent ' + value)
        this.forecastedGrowthPercent = value
      },
      setForecastedGrowthDollar (value) {
        this.forecastedGrowthDollar = value
      },
      setForecastedYear (value) {
        this.forecastedYear = value
      },
      setPriceRange (value) {
        this.priceRange = value
      },
      setHomeTypeSingleFamily (value) {
        this.homeTypeSingleFamily = value
      },
      setHomeTypeMultiFamily (value) {
        this.homeTypeMultiFamily = value
      },
      setHomeTypeApartment (value) {
        this.homeTypeApartment = value
      },
      setHomeTypeLand (value) {
        this.homeTypeLand = value
      },
      setHomeTypeOthers (value) {
        this.homeTypeOthers = value
      },
      setHomeTypes (value) {
        this.homeTypes = value
      },
      setPropertyDetails (value) {
        this.propertyDetails = value
      },
      setPropertyDetailsParkingSpot (value) {
        this.propertyDetailsParkingSpot = value
      },
      setPropertyDetailsGarage (value) {
        this.propertyDetailsGarage = value
      },
      setPropertyDetailsForeclosed (value) {
        this.propertyDetailsForeclosed = value
      },
      setPropertyDetailsPool (value) {
        this.propertyDetailsPool = value
      },
      setPropertyDetailsBasement (value) {
        this.propertyDetailsBasement = value
      },
      removeFilter (item) {
        if (item.indexOf('Min Beds') !== -1) {
          this.numBedroomsMin = 'No Minimum'
        }
        if (item.indexOf('Max Beds') !== -1) {
          this.numBedroomsMax = 'No Maximum'
        }
        if (item.indexOf('Min Baths') !== -1) {
          this.numBathroomsMin = 'No Minimum'
        }
        if (item.indexOf('Max Baths') !== -1) {
          this.numBathroomsMax = 'No Maximum'
        }

        if (item === 'Single Family') {
          this.homeTypeSingleFamily = null
        }
        if (item === 'Multi Family') {
          this.homeTypeMultiFamily = null
        }
        if (item === 'Land') {
          this.homeTypeLand = null
        }
        if (item === 'Apartment') {
          this.homeTypeApartment = null
        }
        if (item === 'Others') {
          this.homeTypeOthers = null
        }

        if (item === 'Parking Spot') {
          this.propertyDetailsParkingSpot = null
        }
        if (item === 'Garage') {
          this.propertyDetailsGarage = null
        }
        if (item === 'Foreclosed') {
          this.propertyDetailsForeclosed = null
        }
        if (item === 'Pool') {
          this.propertyDetailsPool = null
        }
        if (item === 'Basement') {
          this.propertyDetailsBasement = null
        }

        if (item.indexOf('yr % growth') !== -1) {
          this.forecastedGrowthPercent = 0
        }
        if (item.indexOf('yr $ growth') !== -1) {
          this.forecastedGrowthDollar = 0
        }
        if (item.indexOf('Valuation') !== -1) {
          this.priceRange = 0
        }

        this.load()
      },
    },

  }

</script>

<style lang="sass">
  #search-listings
    border-top: 4px solid $color-orange

    .v-btn
      color: white
      font-weight: 600
      letter-spacing: 0.04em

      &.heart-icon
        color: #ccc

      .v-icon
        font-size: 1rem
        padding-left: 5px

    .green-buttons
      .v-btn
        background-color: $color-emerald
        margin-right: 6px
        margin-bottom: 20px
        font-size: 15px

    .squash-buttons

      .v-btn
        background-color: $color-squash

    .found-properties-header
      max-width: 460px
      margin: 0 auto

      h2
        span:not(.v-chip__content)
          display: inline-block
          font-size: 14px
          border-top: 1px solid $color-gray-vlt
          border-left: 1px solid $color-gray-vlt
          width: auto
          color: $color-gray-mddk
          padding: 0 10px

  #search-listings-content > .col
    border-top: 1px solid $color-gray-lt

  #map-col
    background-color: $color-gray-vlt
    padding: 0

  #map
    width: 100%
    height: 90vh
    margin: 0
    padding: 0

    .gm-style-iw-d .addressinfo
      color: black
      font-size: 14px
      font-family: "Avant Garde Gothic Md", "lato", sans-serif
      border-bottom: 2px solid $color-gray-lt
      margin-bottom: 3px
      padding-bottom: 3px

    .gm-style-iw-d .priceline
      display: block
      padding-top: 3px
      font-family: "lato", sans-serif
      font-size: 12px
      font-weight: bold

    .gm-style-iw-d .priceline .pricecat
      font-weight: normal
      padding-left: 3px

    .gm-style-iw-d .priceline.pl-valuation
      color: $color-emerald

  .found-properties-column
    overflow: scroll
    height: 90vh
    border-left: 1px solid $color-gray-lt
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2)

  .listings-item-row

  .listings-error
    padding: 10px
    background: rgb(255, 248, 225)
    border: 1px solid rgb(200, 130, 5)
</style>

<style>
.filters-heading {
  margin-top: 10px;
  margin-bottom: 6px;
  margin-left: 8px;
  font-size: 18px;
  font-family: "Avant Garde Gothic Md", "lato", sans-serif;
}
.first-filter-button {
  margin-left: 8px;
}
@media (max-width: 960px) {
  #search-listings .green-buttons .v-btn {
    margin-bottom: 6px;
    font-size: 12px;
  }

  #search-listings .squash-buttons.text-center {
    text-align: left !important;
    margin-top: 3px;
    padding-top: 0;
  }
}
@media (max-width: 530px) {
  #search-listings .green-buttons .v-btn {
    margin-left: 6px;
    margin-right: 0;
  }
  .filters-heading {
    margin-left: 10px;
  }
  .singleListingMobile {
    display: none;
  }
}
</style>
